import React, { Component } from 'react';
import { Title } from 'react-admin';
import PeopleIcon from '@material-ui/icons/People';
import { withStyles } from '@material-ui/core/styles';
import CardStats from '../../components/CardStats';
import api from '../../lib/api';
import DashboardMenu from './DashboardMenu';
import LoadingOverlay from 'react-loading-overlay';

const styles = {
  main: {
    display: 'flex',
    flexWrap: 'wrap',
    // justifyContent: 'center',
  },
  item: {
    flexGrow: 1,
    width: '100%',
    // marginLeft: '1em',
    marginTop: 40,
  },
  item_1_3: {
    flexGrow: 1,
    width: '32%',
    marginLeft: '1em',
    marginTop: 40,
  },
};

class DashboardCards extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      loading: true,
      error: null,
    };
  }

  componentDidMount() {
    api({
      url: `/dashboard/stats`,
      method: 'GET',
    })
      .then(response => this.setState({ data: response.data, loading: false }))
      .catch(error => this.setState({ error, loading: false }))
      .finally(() => this.setState({ loading: false }));
  }

  render() {
    const { classes } = this.props;
    const { data, loading, error } = this.state;

    if (loading)
      return (
        <LoadingOverlay
          styles={{
            overlay: base => ({
              ...base,
              background: '#2196f357',
              borderRadius: '10px',
            }),
          }}
          active={loading}
          spinner
          text="Caricamento..."
        >
          <div style={{ paddingTop: '100vh' }} />
        </LoadingOverlay>
      );
    if (error) return <p>Error: {error.message}</p>;

    // Usa i dati recuperati
    const activeCompany = data.activeCompany || [];
    const activeCoach = data.activeCoach || [];
    const expiringSubscriptions = data.expiringSubscriptions || [];
    const expiredSubscriptions = data.expiredSubscriptions || [];
    const todayLoggedUser = data.todayLoggedUser || [];
    const prev5DaysLoggedUserWithFreePlan = data.prev5DaysLoggedUserWithFreePlan || [];
    const staffActive = data.staffActive || [];
    const staffTotal = data.staffTotal || [];

    const getActiveSubscription = item =>
      item.subscriptions.find(
        sub =>
          new Date(sub.start_at).getTime() <= new Date().getTime() &&
          new Date().getTime() < new Date(sub.end_at).getTime(),
      );

    const getLastActiveSubscription = item =>
      item.subscriptions.find(
        sub =>
          new Date(sub.end_at).getTime() < new Date(new Date().setDate(new Date().getDate() + 1)) &&
          new Date(sub.end_at).getTime() >= new Date(new Date().setDate(new Date().getDate() - 31)),
      );

    const isOldProUser = item => {
      return item.subscriptions.find(
        sub =>
          new Date(sub.end_at).getTime() < new Date().getTime() /** Sub expired */ &&
          (sub.plan && sub.plan.identifier !== 'free' && sub.plan.identifier !== 'free_company'),
      );
    };

    return (
      <div>
        <Title title="Dashboard Cards" />

        <DashboardMenu active="cards" />

        <div className={classes.main}>
          {/* Active Company */}
          <div className={classes.item}>
            <CardStats
              Icon={PeopleIcon}
              iconBgColor="green"
              label="Società con abbonamento"
              value={activeCompany.length}
              list={activeCompany}
              tbody={
                <tbody>
                  <tr>
                    <th style={{ width: '20%' }}>id</th>
                    <th style={{ width: '20%' }}>Telefono</th>
                    <th style={{ width: '20%' }}>Email</th>
                    <th style={{ width: '20%' }}>Piano</th>
                    <th style={{ width: '20%' }}>N°Coach</th>
                  </tr>
                  {activeCompany.map((item, index) => (
                    <tr key={index}>
                      <td style={{ width: '20%' }}>{item.id}</td>
                      <td style={{ width: '20%' }}>{item.phone_number || ''}</td>
                      <td style={{ width: '20%' }}>{item.email}</td>
                      <td style={{ width: '20%' }}>{getActiveSubscription(item).plan.name}</td>
                      <td style={{ width: '20%' }}>{item.company.coaches ? item.company.coaches.length : 0}</td>
                    </tr>
                  ))}
                </tbody>
              }
            />
          </div>

          {/* Active Coaches */}
          <div className={classes.item}>
            <CardStats
              Icon={PeopleIcon}
              iconBgColor="green"
              label="Coach con abbonamento attivo ( o ereditato da società )"
              value={activeCoach.length}
              list={activeCoach}
              tbody={
                <tbody>
                  <tr>
                    <th style={{ width: '17%' }}>id</th>
                    <th style={{ width: '17%' }}>Telefono</th>
                    <th style={{ width: '17%' }}>Email</th>
                    <th style={{ width: '17%' }}>Plan</th>
                    <th style={{ width: '17%' }}>N°Staff</th>
                    <th style={{ width: '17%' }}>Società</th>
                  </tr>
                  {activeCoach.map((item, index) => (
                    <tr key={index}>
                      <td style={{ width: '17%' }}>{item.id}</td>
                      <td style={{ width: '17%' }}>{item.phone_number || ''}</td>
                      <td style={{ width: '17%' }}>{item.email}</td>
                      <td style={{ width: '17%' }}>
                        {getActiveSubscription(item) ? getActiveSubscription(item).plan.name : 'Ereditato'}
                      </td>
                      <td style={{ width: '17%' }}>{item.coach && item.coach.staff ? item.coach.staff.length : 0}</td>
                      <td style={{ width: '17%' }}>
                        {item.coach && item.coach.company ? item.coach.company.name : 'No'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              }
            />
          </div>

          {/* Todays Login */}
          <div className={classes.item}>
            <CardStats
              Icon={PeopleIcon}
              iconBgColor="green"
              label="Utenti con login effettuato attualmente / in giornata"
              value={todayLoggedUser.length}
              list={todayLoggedUser}
              tbody={
                <tbody>
                  <tr>
                    <th style={{ width: '20%' }}>id</th>
                    <th style={{ width: '20%' }}>Telefono</th>
                    <th style={{ width: '20%' }}>Email</th>
                    <th style={{ width: '20%' }}>Piano</th>
                    <th style={{ width: '20%' }}>E'una società?</th>
                  </tr>
                  {todayLoggedUser.map((item, index) => (
                    <tr key={index}>
                      <td style={{ width: '20%' }}>{item.id}</td>
                      <td style={{ width: '20%' }}>{item.phone_number || ''}</td>
                      <td style={{ width: '20%' }}>{item.email}</td>
                      <td style={{ width: '20%' }}>
                        {getActiveSubscription(item) ? getActiveSubscription(item).plan.name : 'Ereditato'}
                      </td>
                      <td style={{ width: '20%' }}>{item.company ? 'Si' : 'No'}</td>
                    </tr>
                  ))}
                </tbody>
              }
            />
          </div>

          {/* Todays login of free user - or not inherited users */}
          <div className={classes.item}>
            <CardStats
              Icon={PeopleIcon}
              iconBgColor="green"
              label="Utenti con login effettuato negli ultimi 5 giorni con piano free"
              value={prev5DaysLoggedUserWithFreePlan.length}
              list={prev5DaysLoggedUserWithFreePlan}
              tbody={
                <tbody>
                  <tr>
                    <th style={{ width: '17%' }}>id</th>
                    <th style={{ width: '17%' }}>Telefono</th>
                    <th style={{ width: '17%' }}>Email</th>
                    <th style={{ width: '17%' }}>Piano</th>
                    <th style={{ width: '17%' }}>Ex Abbonato?</th>
                    <th style={{ width: '17%' }}>Società</th>
                    <th style={{ width: '17%' }}>Login il</th>
                    <th style={{ width: '17%' }}>&nbsp;</th>
                  </tr>
                  {prev5DaysLoggedUserWithFreePlan.map((item, index) => (
                    <tr key={index}>
                      <td style={{ width: '17%' }}>{item.id}</td>
                      <td style={{ width: '17%' }}>{item.phone_number || ''}</td>
                      <td style={{ width: '17%' }}>{item.email}</td>
                      <td style={{ width: '17%' }}>
                        {getActiveSubscription(item) ? getActiveSubscription(item).plan.name : ''}
                      </td>
                      <td style={{ width: '17%' }}>
                        {isOldProUser(item) ? `Si con piano ${isOldProUser(item).plan.name}` : 'No'}
                      </td>
                      <td style={{ width: '17%' }}>
                        {item.coach && item.coach.company ? item.coach.company.name : 'No'}
                      </td>
                      <td style={{ width: '17%' }}>
                        {new Date(item.last_login_at).getDate()}/{new Date(item.last_login_at).getMonth() + 1}/
                        {new Date(item.last_login_at).getFullYear()}
                      </td>
                      <td>
                        <a target="_blank" href={`/#/users/${item.id}/show/login_list`}>
                          Lista login
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              }
            />
          </div>

          {/* Staff users */}
          <div className={classes.item}>
            <CardStats
              Icon={PeopleIcon}
              iconBgColor="green"
              label="Utenti di tipo staff"
              value={staffTotal.length}
              list={staffTotal}
              tbody={
                <tbody>
                  <tr>
                    <th>id staff</th>
                    <th>email</th>
                    <th>id coach</th>
                    <th>coach</th>
                  </tr>
                  {staffTotal.map((item, index) => (
                    <tr key={index}>
                      <td>{item.id}</td>
                      <td>{item.email}</td>
                      <td>{item.staff.coach.id}</td>
                      <td>
                        {item.staff.coach.first_name} {item.staff.coach.last_name}
                      </td>
                    </tr>
                  ))}
                </tbody>
              }
            />
          </div>

          {/* Staff users with active sub */}
          <div className={classes.item}>
            <CardStats
              Icon={PeopleIcon}
              iconBgColor="green"
              label="Utenti di tipo staff con coach abbonato"
              value={staffActive.length}
              list={staffActive}
              tbody={
                <tbody>
                  <tr>
                    <th>id staff</th>
                    <th>email</th>
                    <th>id coach</th>
                    <th>coach</th>
                  </tr>
                  {staffActive.map((item, index) => (
                    <tr key={index}>
                      <td>{item.id}</td>
                      <td>{item.email}</td>
                      <td>{item.staff.coach.id}</td>
                      <td>
                        {item.staff.coach.first_name} {item.staff.coach.last_name}
                      </td>
                    </tr>
                  ))}
                </tbody>
              }
            />
          </div>

          {/* Sub in expiration for next 30gg */}
          <div className={classes.item}>
            <CardStats
              Icon={PeopleIcon}
              iconBgColor="green"
              label="Coach o Società con abbonamento in scadenza nei prossimi 30gg"
              value={expiringSubscriptions.length}
              list={expiringSubscriptions}
              tbody={
                <tbody>
                  <tr>
                    <th style={{ width: '5%' }}>id</th>
                    <th style={{ width: '5%' }}>Telefono</th>
                    <th style={{ width: '25%' }}>Email</th>
                    <th style={{ width: '25%' }}>Nome</th>
                    <th style={{ width: '10%' }}>Piano</th>
                    <th style={{ width: '25%' }}>Scadenza</th>
                    <th style={{ width: '5%' }}>E'una società?</th>
                  </tr>
                  {expiringSubscriptions.map((item, index) => (
                    <tr key={index}>
                      <td style={{ width: '10%' }}>{item.id}</td>
                      <td style={{ width: '10%' }}>{item.phone_number || ''}</td>
                      <td style={{ width: '25%' }}>{item.email || ''}</td>
                      <td style={{ width: '25%' }}>
                        {item.company ? item.company.full_name || '' : item.coach.full_name || ''}
                      </td>
                      <td style={{ width: '10%' }}>{getActiveSubscription(item).plan.name}</td>
                      <td style={{ width: '25%' }}>
                        {new Date(getActiveSubscription(item).end_at).getDate()}/
                        {new Date(getActiveSubscription(item).end_at).getMonth() + 1}/
                        {new Date(getActiveSubscription(item).end_at).getFullYear()}
                      </td>
                      <td style={{ width: '5%' }}>{item.company ? 'Si' : 'No'}</td>
                    </tr>
                  ))}
                </tbody>
              }
            />
          </div>

          {/* Sub expired in previous 30gg */}
          <div className={classes.item}>
            <CardStats
              Icon={PeopleIcon}
              iconBgColor="green"
              label="Coach o Società con abbonamento scaduto negli ultimi 30gg"
              value={expiredSubscriptions.length}
              list={expiredSubscriptions}
              tbody={
                <tbody>
                  <tr>
                    <th style={{ width: '5%' }}>id</th>
                    <th style={{ width: '5%' }}>Telefono</th>
                    <th style={{ width: '25%' }}>Email</th>
                    <th style={{ width: '25%' }}>Nome</th>
                    <th style={{ width: '10%' }}>Piano</th>
                    <th style={{ width: '25%' }}>Scadenza</th>
                    <th style={{ width: '5%' }}>E'una società?</th>
                  </tr>
                  {expiredSubscriptions.map((item, index) => (
                    <tr key={index}>
                      <td style={{ width: '5%' }}>{item.id}</td>
                      <td style={{ width: '5%' }}>{item.phone_number || ''}</td>
                      <td style={{ width: '25%' }}>{item.email || ''}</td>
                      <td style={{ width: '25%' }}>
                        {item.company ? item.company.full_name || '' : item.coach.full_name || ''}
                      </td>
                      <td style={{ width: '10%' }}>
                        {getLastActiveSubscription(item) ? getLastActiveSubscription(item).plan.name : ''}
                      </td>
                      <td style={{ width: '25%' }}>
                        {getLastActiveSubscription(item)
                          ? `${new Date(getLastActiveSubscription(item).end_at).getDate()}/`
                          : ''}
                        {getLastActiveSubscription(item)
                          ? `${new Date(getLastActiveSubscription(item).end_at).getMonth() + 1}/`
                          : ''}
                        {getLastActiveSubscription(item)
                          ? `${new Date(getLastActiveSubscription(item).end_at).getFullYear()}`
                          : ''}
                      </td>
                      <td style={{ width: '5%' }}>{item.company ? 'Si' : 'No'}</td>
                    </tr>
                  ))}
                </tbody>
              }
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(DashboardCards);



// WEBPACK FOOTER //
// ./src/resources/dashboard/DashboardCards.jsx